$(document).ready(function () {
    $('.filter-mobile-btn').on('click', function () {
        $('.instructor-sidebar-filter').toggleClass('active');
    })
    $('.instructor-sidebar--left--close-mobile').on('click', function () {
        $('.instructor-sidebar-filter').toggleClass('active');
    })
    removeNoteSelectValidDate();
    $('[data-toggle="popover"]').popover({
        trigger: "hover",
    });
    localStorage.removeItem("instructor_selected");
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > 60) {
            $("header").addClass("fixed");
        } else {
            $("header").removeClass("fixed");
        }
    });
});
$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});
window.removeNoteSelectValidDate = function () {
    setTimeout(function () {
        var validDate = $('input[name="birthday"]').val();
        console.log("removeNoteSelectValidDate");
        console.log("removeNoteSelectValidDate", validDate);
        if (validDate && validDate.trim().length > 0) {
            $(".note-select-valid-date").remove();
        }
    }, 1000);

    $('input[name="birthday"]').on("change", function (e) {
        var validDate = $(this).val();
        if (validDate.trim().length > 0) {
            $(this)
                .closest(".form-group")
                .find(".note-select-valid-date")
                .remove();
        }
    });
};
window.loadBannerIframe = function () {
    // $('.elementor-background-video-container').append('<iframe src="https://player.vimeo.com/video/547433531?h=e3036ce9e5&amp;muted=1&amp;autoplay=1&amp;loop=1&amp;transparent=0&amp;background=1&amp;app_id=122963" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" title="Evolution - Desktop" data-ready="true" class="elementor-background-video-embed"></iframe>\n');
};
window.loadingBtn = function ($this) {
    $($this).prop("disabled", true);
    var btnText = $($this).text();
    $($this)
        .empty()
        .append('<i class="fa fa-spinner fa-spin"></i> ' + btnText);
    return btnText;
};
window.removeLoadingBtn = function ($this, text) {
    $($this).prop("disabled", false);
    $($this).empty().append(text);
};
window.parseErrorForm = function (errors, formId) {
    resetErrorForm(formId);
    var errorsObjs = JSON.parse(JSON.stringify(errors));
    $(formId + ' input[type="password"]').each(function (el) {
        var tagName = $(this).attr("name");

        if (errorsObjs[tagName]) {
            var input = $(formId + ' input[name="' + tagName + '"]');
            input.addClass("is-invalid");
            input
                .parent()
                .append(
                    '<div class="invalid-feedback">' +
                        errorsObjs[tagName][0] +
                        "</div>",
                );
        }
    });
    $(formId + ' input[type="text"]').each(function (el) {
        var tagName = $(this).attr("name");
        if (errorsObjs[tagName]) {
            var input = $(formId + ' input[name="' + tagName + '"]');
            input.addClass("is-invalid");
            input
                .parent()
                .append(
                    '<div class="invalid-feedback">' +
                        errorsObjs[tagName][0] +
                        "</div>",
                );
        }
    });
    $(formId + ' input[type="email"]').each(function (el) {
        var tagName = $(this).attr("name");
        if (errorsObjs[tagName]) {
            var input = $(formId + ' input[name="' + tagName + '"]');
            input.addClass("is-invalid");
            input
                .parent()
                .append(
                    '<div class="invalid-feedback">' +
                        errorsObjs[tagName][0] +
                        "</div>",
                );
        }
    });
    $(formId + ' input[type="date"]').each(function (el) {
        var tagName = $(this).attr("name");
        if (errorsObjs[tagName]) {
            var input = $(formId + ' input[name="' + tagName + '"]');
            input.addClass("is-invalid");
            input
                .parent()
                .append(
                    '<div class="invalid-feedback">' +
                        errorsObjs[tagName][0] +
                        "</div>",
                );
        }
    });

    var listRadioName = [];
    $(formId + ' input[type="radio"]').each(function (el) {
        var tagName = $(this).attr("name");
        if (listRadioName.indexOf(tagName) < 0) {
            listRadioName.push(tagName);
        }
    });
    listRadioName.forEach(function (tagName) {
        if (errorsObjs[tagName]) {
            var input = $(formId + ' input[name="' + tagName + '"]');
            input.addClass("is-invalid");
            input.parent().parent().addClass("is-invalid");
            input
                .parent()
                .parent()
                .append(
                    '<div class="invalid-feedback">' +
                        errorsObjs[tagName][0] +
                        "</div>",
                );
        }
    });
    var listCheckBoxName = [];
    $(formId + ' input[type="checkbox"]').each(function (el) {
        var tagName = $(this).attr("name");
        if (listCheckBoxName.indexOf(tagName) < 0) {
            listCheckBoxName.push(tagName);
        }
    });
    listCheckBoxName.forEach(function (tagName) {
        if (errorsObjs[tagName]) {
            var input = $(formId + ' input[name="' + tagName + '"]');
            input.addClass("is-invalid");
            input.parent().parent().addClass("is-invalid");
            input
                .parent()
                .parent()
                .append(
                    '<div class="invalid-feedback">' +
                        errorsObjs[tagName][0] +
                        "</div>",
                );
        }
    });

    $(formId + " select").each(function (el) {
        var tagName = $(this).attr("name");
        var tagNameParam = tagName.replace("[]", "");
        if (errorsObjs[tagNameParam]) {
            var selectTag = $(formId + ' select[name="' + tagName + '"]');
            var parent = $(selectTag).parent();
            selectTag.addClass("is-invalid");
            parent.addClass("is-invalid");
            selectTag
                .parent()
                .append(
                    '<div class="invalid-feedback">' +
                        errorsObjs[tagNameParam] +
                        "</div>",
                );
        }
    });

    $(formId + ' input[type="file"]').each(function (el) {
        var tagName = $(this).attr("name");
        if (errorsObjs[tagName]) {
            var input = $(formId + ' input[name="' + tagName + '"]');
            input.addClass("is-invalid");
            input
                .parent()
                .append(
                    '<div class="invalid-feedback">' +
                        errorsObjs[tagName][0] +
                        "</div>",
                );
        }
    });
    $(formId + " textarea").each(function (el) {
        var tagName = $(this).attr("name");
        if (errorsObjs[tagName]) {
            var input = $(formId + ' textarea[name="' + tagName + '"]');
            if ($(`${formId} .redactor-box`).length) {
                input.parents().eq(1).addClass("is-invalid");
                input
                    .parents()
                    .eq(1)
                    .append(
                        '<div class="invalid-feedback">' +
                            errorsObjs[tagName][0] +
                            "</div>",
                    );
            } else {
                input.addClass("is-invalid");
                input
                    .parent()
                    .append(
                        '<div class="invalid-feedback">' +
                            errorsObjs[tagName][0] +
                            "</div>",
                    );
            }
        }
    });
};
window.resetErrorForm = function (formId) {
    $(formId + " .invalid-feedback").remove();
    $(".is-invalid").each(function () {
        $(this).removeClass("is-invalid");
    });
};
window.topic_main_home = function () {
    var dataforch = $(window).width();
    if (dataforch < 768) {
        $(".cutome_all_topics_main").slick({
            dots: true,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
            ],
        });
    }
};
window.validateEmail = function (email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
};
window.selectChangeCountryWizard = function () {
    var jsonFormet = getJsonFormatCountries();
    $(".change-select-country-profile-wizard").on("click", function () {
        var cont = $(".change-select-country-profile-wizard > select").val();
        var select_value = $('[data-countryCode="' + cont + '"]').val();
        $("#countryCode").val(select_value);
        $("#eventsCalCountry").val(cont);
        onCountryChange();
        var countricodedd = getValue(cont, jsonFormet);
        var datad = getValue("phone_formet", countricodedd);

        $("#mnumber").inputmask({
            mask: [datad, datad],
            jitMasking: 3,
            showMaskOnHover: false,
            autoUnmask: true,
        });
        var olDataPhone = $("#mnumber").val();
        $("#mnumber").val(olDataPhone);
    });
    $(".change-select-country-profile-wizard > select").on(
        "change",
        function () {
            var cont = $(this).val();
            var select_value = $('[data-countryCode="' + cont + '"]').val();
            $("#countryCode").val(select_value);
            $("#eventsCalCountry").val(cont);
            onCountryChange();
            var countricodedd = getValue(cont, jsonFormet);
            var datad = getValue("phone_formet", countricodedd);

            $("#mnumber").inputmask({
                mask: [datad, datad],
                jitMasking: 3,
                showMaskOnHover: false,
                autoUnmask: true,
            });
            var olDataPhone = $("#mnumber").val();
            $("#mnumber").val(olDataPhone);
        },
    );
    $('input[name="fname"]').on("focus", function () {
        var htmlSelect = $('select[name="country"]');
        var htmlSelectId = htmlSelect.attr("id");
        var uniqueId = htmlSelectId.replace("flagstrap-", "");
        var country_value = htmlSelect.val();
        $("#flagstrap-drop-down-" + uniqueId + "-list li a").each(
            function (val) {
                var aAttr = $(this).attr("data-val");
                if (aAttr === country_value) {
                    $(".flagstrap-selected-" + uniqueId).html($(this).html());
                }
            },
        );
    });
};
window.onCountryChange = function () {
    console.log("onCountryChange");
    var timezone_json = getTimeZoneJson();
    $("#eventsCalTimezone").empty();
    var countryCode = $("#eventsCalCountry").val();
    localStorage.setItem("selected_country", countryCode);
    localStorage.setItem(
        "selected_country_code_phone",
        $('select[name="countryCode"]').val(),
    );

    // for (var i in timezone_json[countryCode])
    // {
    //     var timezoneObj = timezone_json[countryCode][i];
    //    // var now = moment(new Date())
    //    // $("#eventsCalTimezone").append("<option value='" + timezoneObj.tzid + "'>" + "(UTC" + moment.tz(now, timezoneObj.tzid).format('Z') + ") " + timezoneObj.name)
    // }
    $.ajax({
        url: "/ajax/get-offset-timezone-utc",
        data: {
            countryCode: countryCode,
            timezones: timezone_json[countryCode],
        },
        method: "POST",
        success: function (res) {
            var timezones = res.data.timezones;
            if (timezones.length) {
                $("#eventsCalTimezone").empty();
                timezones.forEach(function (val) {
                    let option =
                        "<option data-offset='" +
                        val.offset +
                        "'  value='" +
                        val.tzid +
                        "'";
                    if (val.user_is_logged && val.selected) {
                        option += " selected ";
                    }
                    option +=
                        option +
                        ">" +
                        val.offsetDisplay +
                        " " +
                        val.name +
                        "</option>";
                    $("#eventsCalTimezone").append(option);
                });
            }
        },
    });
};
window.getJsonFormatCountries = function () {
    var jsonFormat = [
        { IL: [{ name: "Israel", dial_code: "+972", code: "IL" }] },
        {
            AF: [
                {
                    name: "Afghanistan",
                    dial_code: "+93",
                    code: "AF",
                    phone_numbar: 9,
                    phone_formet: "99 999 9999",
                },
            ],
        },
        {
            AL: [
                {
                    name: "Albania",
                    dial_code: "+355",
                    code: "AL",
                    phone_numbar: 9,
                    phone_formet: "99 999 9999",
                },
            ],
        },
        {
            DZ: [
                {
                    name: "Algeria",
                    dial_code: "+213",
                    code: "DZ",
                    phone_numbar: 9,
                    phone_formet: "99 999 99 99",
                },
            ],
        },
        {
            AS: [
                {
                    name: "AmericanSamoa",
                    dial_code: "+1 684",
                    code: "AS",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            AD: [
                {
                    name: "Andorra",
                    dial_code: "+376",
                    code: "AD",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            AO: [
                {
                    name: "Angola",
                    dial_code: "+244",
                    code: "AO",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            AI: [
                {
                    name: "Anguilla",
                    dial_code: "+1 264",
                    code: "AI",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            AG: [
                {
                    name: "Antigua and Barbuda",
                    dial_code: "+1 268",
                    code: "AG",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            AR: [
                {
                    name: "Argentina",
                    dial_code: "+54",
                    code: "AR",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            AM: [
                {
                    name: "Armenia",
                    dial_code: "+374",
                    code: "AM",
                    phone_numbar: 8,
                    phone_formet: "999 99 999",
                },
            ],
        },
        {
            AW: [
                {
                    name: "Aruba",
                    dial_code: "+297",
                    code: "AW",
                    phone_numbar: 7,
                    phone_formet: "99 99 999",
                },
            ],
        },
        {
            AU: [
                {
                    name: "Australia",
                    dial_code: "+61",
                    code: "AU",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                    max_phone_numba_: 15,
                    min_phone_numba_: 5,
                },
            ],
        },
        {
            AT: [
                {
                    name: "Austria",
                    dial_code: "+43",
                    code: "AT",
                    phone_numbar: 10,
                    phone_formet: "99 9999 9999",
                    max_phone_numba_: 13,
                    min_phone_numba_: 4,
                },
            ],
        },
        {
            AZ: [
                {
                    name: "Azerbaijan",
                    dial_code: "+994",
                    code: "AZ",
                    phone_numbar: 9,
                    phone_formet: "99 999 99 99",
                },
            ],
        },
        {
            BS: [
                {
                    name: "Bahamas",
                    dial_code: "+1 242",
                    code: "",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            BH: [
                {
                    name: "Bahrain",
                    dial_code: "+973",
                    code: "BH",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            BD: [
                {
                    name: "Bangladesh",
                    dial_code: "+880",
                    code: "BD",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            BB: [
                {
                    name: "Barbados",
                    dial_code: "+1 246",
                    code: "",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            BY: [
                {
                    name: "Belarus",
                    dial_code: "+375",
                    code: "BY",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            BE: [
                {
                    name: "Belgium",
                    dial_code: "+32",
                    code: "BE",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            BZ: [
                {
                    name: "Belize",
                    dial_code: "+501",
                    code: "BZ",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            BJ: [
                {
                    name: "Benin",
                    dial_code: "+229",
                    code: "BJ",
                    phone_numbar: 8,
                    phone_formet: "99 99 99 99",
                },
            ],
        },
        {
            BM: [
                {
                    name: "Bermuda",
                    dial_code: "+1 441",
                    code: "BM",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            BT: [
                {
                    name: "Bhutan",
                    dial_code: "+975",
                    code: "BT",
                    phone_numbar: 8,
                    phone_formet: "99 99 99 99",
                },
            ],
        },
        {
            BA: [
                {
                    name: "Bosnia and Herzegovina",
                    dial_code: "+387",
                    code: "BA",
                    phone_numbar: 8,
                    phone_formet: "99 999 999",
                },
            ],
        },
        {
            BW: [
                {
                    name: "Botswana",
                    dial_code: "+267",
                    code: "BW",
                    phone_numbar: 8,
                    phone_formet: "99 999 999",
                },
            ],
        },
        {
            BR: [
                {
                    name: "Brazil",
                    dial_code: "+55",
                    code: "BR",
                    phone_numbar: 11,
                    phone_formet: "99 99999 9999",
                },
            ],
        },
        {
            IO: [
                {
                    name: "British Indian Ocean Territory",
                    dial_code: "+246",
                    code: "IO",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            BG: [
                {
                    name: "Bulgaria",
                    dial_code: "+359",
                    code: "BG",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            BF: [
                {
                    name: "Burkina Faso",
                    dial_code: "+226",
                    code: "BF",
                    phone_numbar: 8,
                    phone_formet: "999 999 99",
                },
            ],
        },
        {
            BI: [
                {
                    name: "Burundi",
                    dial_code: "+257",
                    code: "BI",
                    phone_numbar: 8,
                    phone_formet: "999 999 99",
                },
            ],
        },
        {
            KH: [
                {
                    name: "Cambodia",
                    dial_code: "+855",
                    code: "KH",
                    phone_numbar: 8,
                    phone_formet: "999 999 99",
                },
            ],
        },
        {
            CM: [
                {
                    name: "Cameroon",
                    dial_code: "+237",
                    code: "CM",
                    phone_numbar: 8,
                },
            ],
        },
        {
            CA: [
                {
                    name: "Canada",
                    dial_code: "+1",
                    code: "CA",
                    phone_numbar: 10,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            CV: [
                {
                    name: "Cape Verde",
                    dial_code: "+238",
                    code: "CV",
                    phone_numbar: 7,
                    phone_formet: "99 99 999",
                },
            ],
        },
        {
            KY: [
                {
                    name: "Cayman Islands",
                    dial_code: "+ 345",
                    code: "KY",
                    phone_numbar: 7,
                    phone_formet: "99 99 999",
                },
            ],
        },
        {
            CF: [
                {
                    name: "Central African Republic",
                    dial_code: "+236",
                    code: "CF",
                    phone_numbar: 8,
                    phone_formet: "999 999 99",
                },
            ],
        },
        {
            TD: [
                {
                    name: "Chad",
                    dial_code: "+235",
                    code: "TD",
                    phone_numbar: 8,
                    phone_formet: "999 999 99",
                },
            ],
        },
        {
            CL: [
                {
                    name: "Chile",
                    dial_code: "+56",
                    code: "CL",
                    phone_numbar: 9,
                    phone_formet: "999 999-99-9",
                },
            ],
        },
        {
            CN: [
                {
                    name: "China",
                    dial_code: "+86",
                    code: "CN",
                    phone_numbar: 12,
                    phone_formet: "999 999-999-999",
                },
            ],
        },
        {
            CX: [
                {
                    name: "Christmas Island",
                    dial_code: "+61",
                    code: "CX",
                    phone_numbar: 7,
                    phone_formet: "99 99 999",
                },
            ],
        },
        {
            CO: [
                {
                    name: "Colombia",
                    dial_code: "+57",
                    code: "CO",
                    phone_numbar: 7,
                    phone_formet: "99 99 999",
                },
            ],
        },
        {
            KM: [
                {
                    name: "Comoros",
                    dial_code: "+269",
                    code: "KM",
                    phone_numbar: 7,
                    phone_formet: "99 99 999",
                },
            ],
        },
        {
            CG: [
                {
                    name: "Congo",
                    dial_code: "+242",
                    code: "CG",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            CK: [
                {
                    name: "Cook Islands",
                    dial_code: "+682",
                    code: "CK",
                    phone_numbar: 5,
                    phone_formet: "99 999",
                },
            ],
        },
        {
            CR: [
                {
                    name: "Costa Rica",
                    dial_code: "+506",
                    code: "CR",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            HR: [
                {
                    name: "Croatia",
                    dial_code: "+385",
                    code: "HR",
                    phone_numbar: 12,
                    phone_formet: "99 999 999 9999",
                },
            ],
        },
        {
            CU: [
                {
                    name: "Cuba",
                    dial_code: "+53",
                    code: "CU",
                    phone_numbar: 8,
                    phone_formet: "9 9999999",
                },
            ],
        },
        {
            CY: [
                {
                    name: "Cyprus",
                    dial_code: "+357",
                    code: "CY",
                    phone_numbar: 8,
                    phone_formet: "99 999999",
                },
            ],
        },
        {
            CZ: [
                {
                    name: "Czech Republic",
                    dial_code: "+420",
                    code: "CZ",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            DK: [
                {
                    name: "Denmark",
                    dial_code: "+45",
                    code: "DK",
                    phone_numbar: 8,
                    phone_formet: "99 99 99 99",
                },
            ],
        },
        {
            DJ: [
                {
                    name: "Djibouti",
                    dial_code: "+253",
                    code: "DJ",
                    phone_numbar: 8,
                    phone_formet: "99 99 99 99",
                },
            ],
        },
        {
            DM: [
                {
                    name: "Dominica",
                    dial_code: "+1 767",
                    code: "DM",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            DO: [
                {
                    name: "Dominican Republic",
                    dial_code: "+1 849",
                    code: "DO",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            EC: [
                {
                    name: "Ecuador",
                    dial_code: "+593",
                    code: "EC",
                    phone_numbar: 8,
                    phone_formet: "9 999 9999",
                },
            ],
        },
        {
            EG: [
                {
                    name: "Egypt",
                    dial_code: "+20",
                    code: "EG",
                    phone_numbar: 8,
                    phone_formet: "99 999999",
                },
            ],
        },
        {
            SV: [
                {
                    name: "El Salvador",
                    dial_code: "+503",
                    code: "SV",
                    phone_numbar: 11,
                    phone_formet: "999 9999 9999",
                },
            ],
        },
        {
            GQ: [
                {
                    name: "Equatorial Guinea",
                    dial_code: "+240",
                    code: "GQ",
                    phone_numbar: 11,
                    phone_formet: "999 9999 9999",
                },
            ],
        },
        {
            ER: [
                {
                    name: "Eritrea",
                    dial_code: "+291",
                    code: "ER",
                    phone_numbar: 7,
                    phone_formet: "9 999 999",
                },
            ],
        },
        {
            EE: [
                {
                    name: "Estonia",
                    dial_code: "+372",
                    code: "EE",
                    phone_numbar: 10,
                    phone_formet: "9999 999 999",
                },
            ],
        },
        {
            ET: [
                {
                    name: "Ethiopia",
                    dial_code: "+251",
                    code: "ET",
                    phone_numbar: 9,
                    phone_formet: "99 999 9999",
                },
            ],
        },
        {
            FO: [
                {
                    name: "Faroe Islands",
                    dial_code: "+298",
                    code: "FO",
                    phone_numbar: 6,
                    phone_formet: "999999",
                },
            ],
        },
        {
            FJ: [
                {
                    name: "Fiji",
                    dial_code: "+679",
                    code: "FJ",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            FI: [
                {
                    name: "Finland",
                    dial_code: "+358",
                    code: "FI",
                    phone_numbar: 9,
                    phone_formet: "99 999 99 99",
                },
            ],
        },
        {
            FR: [
                {
                    name: "France",
                    dial_code: "+33",
                    code: "FR",
                    phone_numbar: 9,
                    phone_formet: "9 99 99 99",
                },
            ],
        },
        {
            GF: [
                {
                    name: "French Guiana",
                    dial_code: "+594",
                    code: "GF",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            PF: [
                {
                    name: "French Polynesia",
                    dial_code: "+689",
                    code: "PF",
                    phone_numbar: 6,
                    phone_formet: "99 99 99",
                },
            ],
        },
        {
            GA: [
                {
                    name: "Gabon",
                    dial_code: "+241",
                    code: "GA",
                    phone_numbar: 7,
                    phone_formet: "9 99 99 99",
                },
            ],
        },
        {
            GM: [
                {
                    name: "Gambia",
                    dial_code: "+220",
                    code: "GM",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            GE: [
                {
                    name: "Georgia",
                    dial_code: "+995",
                    code: "GE",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            DE: [
                {
                    name: "Germany",
                    dial_code: "+49",
                    code: "DE",
                    phone_numbar: 11,
                    phone_formet: "999 9999 9999",
                },
            ],
        },
        {
            GH: [
                {
                    name: "Ghana",
                    dial_code: "+233",
                    code: "GH",
                    phone_numbar: 9,
                    phone_formet: "99 999 9999",
                },
            ],
        },
        {
            GI: [
                {
                    name: "Gibraltar",
                    dial_code: "+350",
                    code: "GI",
                    phone_numbar: 8,
                    phone_formet: "999 99999",
                },
            ],
        },
        {
            GR: [
                {
                    name: "Greece",
                    dial_code: "+30",
                    code: "GR",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            GL: [
                {
                    name: "Greenland",
                    dial_code: "+299",
                    code: "GL",
                    phone_numbar: 6,
                    phone_formet: "99 99 99",
                },
            ],
        },
        {
            GD: [
                {
                    name: "Grenada",
                    dial_code: "+1 473",
                    code: "GD",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            GP: [
                {
                    name: "Guadeloupe",
                    dial_code: "+590",
                    code: "GP",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            GU: [
                {
                    name: "Guam",
                    dial_code: "+1 671",
                    code: "GU",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            GT: [
                {
                    name: "Guatemala",
                    dial_code: "+502",
                    code: "GT",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            GN: [
                {
                    name: "Guinea",
                    dial_code: "+224",
                    code: "GN",
                    phone_numbar: 8,
                    phone_formet: "9 999 9999",
                },
            ],
        },
        {
            GW: [
                {
                    name: "Guinea-Bissau",
                    dial_code: "+245",
                    code: "GW",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            GY: [
                {
                    name: "Guyana",
                    dial_code: "+595",
                    code: "GY",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            HT: [
                {
                    name: "Haiti",
                    dial_code: "+509",
                    code: "HT",
                    phone_numbar: 8,
                    phone_formet: "99 99 9999",
                },
            ],
        },
        {
            HN: [
                {
                    name: "Honduras",
                    dial_code: "+504",
                    code: "HN",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            HU: [
                {
                    name: "Hungary",
                    dial_code: "+36",
                    code: "HU",
                    phone_numbar: 8,
                    phone_formet: "99 999 999",
                },
            ],
        },
        {
            IS: [
                {
                    name: "Iceland",
                    dial_code: "+354",
                    code: "IS",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            IN: [
                {
                    name: "India",
                    dial_code: "+91",
                    code: "IN",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            ID: [
                {
                    name: "Indonesia",
                    dial_code: "+62",
                    code: "ID",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            IQ: [
                {
                    name: "Iraq",
                    dial_code: "+964",
                    code: "IQ",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            IE: [
                {
                    name: "Ireland",
                    dial_code: "+353",
                    code: "IE",
                    phone_numbar: 11,
                    phone_formet: "999 9999 9999",
                },
            ],
        },
        {
            IL: [
                {
                    name: "Israel",
                    dial_code: "+972",
                    code: "IL",
                    phone_numbar: 9,
                    phone_formet: "99 999 9999",
                },
            ],
        },
        {
            IT: [
                {
                    name: "Italy",
                    dial_code: "+39",
                    code: "IT",
                    phone_numbar: 11,
                    phone_formet: "9999 999 9999",
                },
            ],
        },
        {
            JM: [
                {
                    name: "Jamaica",
                    dial_code: "+1 876",
                    code: "JM",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            JP: [
                {
                    name: "Japan",
                    dial_code: "+81",
                    code: "JP",
                    phone_numbar: 13,
                    phone_formet: "9999 99 999 9999",
                },
            ],
        },
        {
            JO: [
                {
                    name: "Jordan",
                    dial_code: "+962",
                    code: "JO",
                    phone_numbar: 9,
                    phone_formet: "9 9999 9999",
                },
            ],
        },
        {
            KZ: [
                {
                    name: "Kazakhstan",
                    dial_code: "+7",
                    code: "KZ",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            KE: [
                {
                    name: "Kenya",
                    dial_code: "+254",
                    code: "KE",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            KI: [
                {
                    name: "Kiribati",
                    dial_code: "+686",
                    code: "KI",
                    phone_numbar: 5,
                    phone_formet: "999 99",
                },
            ],
        },
        {
            KW: [
                {
                    name: "Kuwait",
                    dial_code: "+965",
                    code: "KW",
                    phone_numbar: 8,
                    phone_formet: "999 99999",
                },
            ],
        },
        {
            KG: [
                {
                    name: "Kyrgyzstan",
                    dial_code: "+996",
                    code: "KG",
                    phone_numbar: 9,
                    phone_formet: "9999 99999",
                },
            ],
        },
        {
            LV: [
                {
                    name: "Latvia",
                    dial_code: "+371",
                    code: "LV",
                    phone_numbar: 8,
                    phone_formet: "99 999 999",
                },
            ],
        },
        {
            LB: [
                {
                    name: "Lebanon",
                    dial_code: "+961",
                    code: "LB",
                    phone_numbar: 8,
                    phone_formet: "99 999 999",
                },
            ],
        },
        {
            LS: [
                {
                    name: "Lesotho",
                    dial_code: "+266",
                    code: "LS",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            LR: [
                {
                    name: "Liberia",
                    dial_code: "+231",
                    code: "LR",
                    phone_numbar: 8,
                    phone_formet: "99 999 999",
                },
            ],
        },
        {
            LI: [
                {
                    name: "Liechtenstein",
                    dial_code: "+423",
                    code: "LI",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            LT: [
                {
                    name: "Lithuania",
                    dial_code: "+370",
                    code: "LT",
                    phone_numbar: 8,
                    phone_formet: "9 999 9999",
                },
            ],
        },
        {
            LU: [
                {
                    name: "Luxembourg",
                    dial_code: "+352",
                    code: "LU",
                    phone_numbar: 11,
                    phone_formet: "99 99 99 99 9 99",
                },
            ],
        },
        {
            MG: [
                {
                    name: "Madagascar",
                    dial_code: "+261",
                    code: "MG",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            MW: [
                {
                    name: "Malawi",
                    dial_code: "+265",
                    code: "MW",
                    phone_numbar: 8,
                    phone_formet: "999 999 99",
                },
            ],
        },
        {
            MY: [
                {
                    name: "Malaysia",
                    dial_code: "+60",
                    code: "MY",
                    phone_numbar: 9,
                    phone_formet: "9 9999 9999",
                },
            ],
        },
        {
            MV: [
                {
                    name: "Maldives",
                    dial_code: "+960",
                    code: "MV",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            ML: [
                {
                    name: "Mali",
                    dial_code: "+223",
                    code: "ML",
                    phone_numbar: 8,
                    phone_formet: "99 99 99 99",
                },
            ],
        },
        {
            MT: [
                {
                    name: "Malta",
                    dial_code: "+356",
                    code: "MT",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            MH: [
                {
                    name: "Marshall Islands",
                    dial_code: "+692",
                    code: "MH",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            MQ: [
                {
                    name: "Martinique",
                    dial_code: "+596",
                    code: "MQ",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            MR: [
                {
                    name: "Mauritania",
                    dial_code: "+222",
                    code: "MR",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            MU: [
                {
                    name: "Mauritius",
                    dial_code: "+230",
                    code: "MU",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            YT: [
                {
                    name: "Mayotte",
                    dial_code: "+262",
                    code: "YT",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            MX: [
                {
                    name: "Mexico",
                    dial_code: "+52",
                    code: "MX",
                    phone_numbar: 10,
                    phone_formet: "99 9999 9999",
                },
            ],
        },
        {
            MC: [
                {
                    name: "Monaco",
                    dial_code: "+377",
                    code: "MC",
                    phone_numbar: 9,
                    phone_formet: "9 99 99 99 99",
                },
            ],
        },
        {
            MN: [
                {
                    name: "Mongolia",
                    dial_code: "+976",
                    code: "MN",
                    phone_numbar: 8,
                    phone_formet: "99 99 9999",
                },
            ],
        },
        {
            ME: [
                {
                    name: "Montenegro",
                    dial_code: "+382",
                    code: "ME",
                    phone_numbar: 12,
                    phone_formet: "99 999 999 9999",
                },
            ],
        },
        {
            MS: [
                {
                    name: "Montserrat",
                    dial_code: "+1 664",
                    code: "MS",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            MA: [
                {
                    name: "Morocco",
                    dial_code: "+212",
                    code: "MA",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            MM: [
                {
                    name: "Myanmar",
                    dial_code: "+95",
                    code: "MM",
                    phone_numbar: 9,
                    phone_formet: "9 9999 9999",
                },
            ],
        },
        {
            NA: [
                {
                    name: "Namibia",
                    dial_code: "+264",
                    code: "NA",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            NR: [
                {
                    name: "Nauru",
                    dial_code: "+674",
                    code: "NR",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            NP: [
                {
                    name: "Nepal",
                    dial_code: "+977",
                    code: "NP",
                    phone_numbar: 10,
                    phone_formet: "999 9999999",
                },
            ],
        },
        {
            NL: [
                {
                    name: "Netherlands",
                    dial_code: "+31",
                    code: "NL",
                    phone_numbar: 9,
                    phone_formet: "9 99999999",
                },
            ],
        },
        {
            AN: [
                {
                    name: "Netherlands Antilles",
                    dial_code: "+599",
                    code: "AN",
                    phone_numbar: 9,
                    phone_formet: "9999 99999",
                },
            ],
        },
        {
            NC: [
                {
                    name: "New Caledonia",
                    dial_code: "+687",
                    code: "NC",
                    phone_numbar: 6,
                    phone_formet: "99 99 99",
                },
            ],
        },
        {
            NZ: [
                {
                    name: "New Zealand",
                    dial_code: "+64",
                    code: "NZ",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            NI: [
                {
                    name: "Nicaragua",
                    dial_code: "+505",
                    code: "NI",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            NE: [
                {
                    name: "Niger",
                    dial_code: "+227",
                    code: "NE",
                    phone_numbar: 8,
                    phone_formet: "99 99 99 99",
                },
            ],
        },
        {
            NG: [
                {
                    name: "Nigeria",
                    dial_code: "+234",
                    code: "NG",
                    phone_numbar: 10,
                    phone_formet: "99 999 999 99",
                },
            ],
        },
        {
            NU: [
                {
                    name: "Niue",
                    dial_code: "+683",
                    code: "NU",
                    phone_numbar: 10,
                    phone_formet: "999 9999999",
                },
            ],
        },
        {
            NF: [
                {
                    name: "Norfolk Island",
                    dial_code: "+672",
                    code: "NF",
                    phone_numbar: 9,
                    phone_formet: "999 99 9999",
                },
            ],
        },
        {
            MP: [
                {
                    name: "Northern Mariana Islands",
                    dial_code: "+1 670",
                    code: "MP",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            NO: [
                {
                    name: "Norway",
                    dial_code: "+47",
                    code: "NO",
                    phone_numbar: 8,
                    phone_formet: "99 99 99 99",
                },
            ],
        },
        {
            OM: [
                {
                    name: "Oman",
                    dial_code: "+968",
                    code: "OM",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            PK: [
                {
                    name: "Pakistan",
                    dial_code: "+92",
                    code: "PK",
                    phone_numbar: 11,
                    phone_formet: "99 999 999 999",
                },
            ],
        },
        {
            PW: [
                {
                    name: "Palau",
                    dial_code: "+680",
                    code: "PW",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            PA: [
                {
                    name: "Panama",
                    dial_code: "+507",
                    code: "PA",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            PG: [
                {
                    name: "Papua New Guinea",
                    dial_code: "+675",
                    code: "PG",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            PY: [
                {
                    name: "Paraguay",
                    dial_code: "+595",
                    code: "PY",
                    phone_numbar: 9,
                    phone_formet: "999 999999",
                },
            ],
        },
        {
            PE: [
                {
                    name: "Peru",
                    dial_code: "+51",
                    code: "PE",
                    phone_numbar: 10,
                    phone_formet: "999 9999 9999",
                },
            ],
        },
        {
            PH: [
                {
                    name: "Philippines",
                    dial_code: "+63",
                    code: "PH",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            PL: [
                {
                    name: "Poland",
                    dial_code: "+48",
                    code: "PL",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            PT: [
                {
                    name: "Portugal",
                    dial_code: "+351",
                    code: "PT",
                    phone_numbar: 11,
                    phone_formet: "9999 999 9999",
                },
            ],
        },
        {
            PR: [
                {
                    name: "Puerto Rico",
                    dial_code: "+1 939",
                    code: "PR",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            QA: [
                {
                    name: "Qatar",
                    dial_code: "+974",
                    code: "QA",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            RO: [
                {
                    name: "Romania",
                    dial_code: "+40",
                    code: "RO",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            RW: [
                {
                    name: "Rwanda",
                    dial_code: "+250",
                    code: "RW",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            WS: [
                {
                    name: "Samoa",
                    dial_code: "+685",
                    code: "WS",
                    phone_numbar: 7,
                    phone_formet: "99 99999",
                },
            ],
        },
        {
            SM: [
                {
                    name: "San Marino",
                    dial_code: "+378",
                    code: "SM",
                    phone_numbar: 10,
                    phone_formet: "9999 999999",
                },
            ],
        },
        {
            SA: [
                {
                    name: "Saudi Arabia",
                    dial_code: "+966",
                    code: "SA",
                    phone_numbar: 9,
                    phone_formet: "99 999 9999",
                },
            ],
        },
        {
            SN: [
                {
                    name: "Senegal",
                    dial_code: "+221",
                    code: "SN",
                    phone_numbar: 9,
                    phone_formet: "99 999 99 99",
                },
            ],
        },
        {
            RS: [
                {
                    name: "Serbia",
                    dial_code: "+381",
                    code: "RS",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            SC: [
                {
                    name: "Seychelles",
                    dial_code: "+248",
                    code: "SC",
                    phone_numbar: 7,
                    phone_formet: "9 999 999",
                },
            ],
        },
        {
            SL: [
                {
                    name: "Sierra Leone",
                    dial_code: "+232",
                    code: "SL",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            SG: [
                {
                    name: "Singapore",
                    dial_code: "+65",
                    code: "SG",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            SK: [
                {
                    name: "Slovakia",
                    dial_code: "+421",
                    code: "SK",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            SI: [
                {
                    name: "Slovenia",
                    dial_code: "+386",
                    code: "SI",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            SB: [
                {
                    name: "Solomon Islands",
                    dial_code: "+677",
                    code: "SB",
                    phone_numbar: 5,
                    phone_formet: "999 99",
                },
            ],
        },
        {
            ZA: [
                {
                    name: "South Africa",
                    dial_code: "+27",
                    code: "ZA",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            GS: [
                {
                    name: "South Georgia and the South Sandwich Islands",
                    dial_code: "+500",
                    code: "GS",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            ES: [
                {
                    name: "Spain",
                    dial_code: "+34",
                    code: "ES",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            LK: [
                {
                    name: "Sri Lanka",
                    dial_code: "+94",
                    code: "LK",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            SD: [
                {
                    name: "Sudan",
                    dial_code: "+249",
                    code: "SD",
                    phone_numbar: 9,
                    phone_formet: "999 99 99 99",
                },
            ],
        },
        {
            SR: [
                {
                    name: "Suriname",
                    dial_code: "+597",
                    code: "SR",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            SZ: [
                {
                    name: "Swaziland",
                    dial_code: "+268",
                    code: "SZ",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            SE: [
                {
                    name: "Sweden",
                    dial_code: "+46",
                    code: "SE",
                    phone_numbar: 13,
                    phone_formet: "999 9999 999 999",
                },
            ],
        },
        {
            CH: [
                {
                    name: "Switzerland",
                    dial_code: "+41",
                    code: "CH",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            TJ: [
                {
                    name: "Tajikistan",
                    dial_code: "+992",
                    code: "TJ",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            TH: [
                {
                    name: "Thailand",
                    dial_code: "+66",
                    code: "TH",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            TG: [
                {
                    name: "Togo",
                    dial_code: "+228",
                    code: "TG",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            TK: [
                {
                    name: "Tokelau",
                    dial_code: "+690",
                    code: "TK",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            TO: [
                {
                    name: "Tonga",
                    dial_code: "+676",
                    code: "TO",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            TT: [
                {
                    name: "Trinidad and Tobago",
                    dial_code: "+1 868",
                    code: "TT",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            TN: [
                {
                    name: "Tunisia",
                    dial_code: "+216",
                    code: "TN",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            TR: [
                {
                    name: "Turkey",
                    dial_code: "+90",
                    code: "TR",
                    phone_numbar: 10,
                    phone_formet: "999 9999 999",
                },
            ],
        },
        {
            TR: [
                {
                    name: "Turkmenistan",
                    dial_code: "+993",
                    code: "TM",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            TC: [
                {
                    name: "Turks and Caicos Islands",
                    dial_code: "+1 649",
                    code: "TC",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            TV: [
                {
                    name: "Tuvalu",
                    dial_code: "+688",
                    code: "TV",
                    phone_numbar: 6,
                    phone_formet: "999 999",
                },
            ],
        },
        {
            UG: [
                {
                    name: "Uganda",
                    dial_code: "+256",
                    code: "UG",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            UA: [
                {
                    name: "Ukraine",
                    dial_code: "+380",
                    code: "UA",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            AE: [
                {
                    name: "United Arab Emirates",
                    dial_code: "+971",
                    code: "AE",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            GB: [
                {
                    name: "United Kingdom",
                    dial_code: "+44",
                    code: "GB",
                    phone_numbar: 10,
                    phone_formet: "999 9999 999",
                },
            ],
        },
        {
            US: [
                {
                    name: "United States",
                    dial_code: "+1",
                    code: "US",
                    phone_numbar: 10,
                    phone_formet: "999 9999 999",
                },
            ],
        },
        {
            UY: [
                {
                    name: "Uruguay",
                    dial_code: "+598",
                    code: "UY",
                    phone_numbar: 11,
                    phone_formet: "999 999 999 99",
                },
            ],
        },
        {
            UZ: [
                {
                    name: "Uzbekistan",
                    dial_code: "+998",
                    code: "UZ",
                    phone_numbar: 11,
                    phone_formet: "999 999 999 99",
                },
            ],
        },
        {
            VU: [
                {
                    name: "Vanuatu",
                    dial_code: "+678",
                    code: "VU",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            WF: [
                {
                    name: "Wallis and Futuna",
                    dial_code: "+681",
                    code: "WF",
                    phone_numbar: 6,
                    phone_formet: "999 999",
                },
            ],
        },
        {
            YE: [
                {
                    name: "Yemen",
                    dial_code: "+967",
                    code: "YE",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            ZM: [
                {
                    name: "Zambia",
                    dial_code: "+260",
                    code: "ZM",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            ZW: [
                {
                    name: "Zimbabwe",
                    dial_code: "+263",
                    code: "ZW",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            AX: [
                {
                    name: "land Islands",
                    dial_code: "",
                    code: "AX",
                    phone_numbar: 6,
                    phone_formet: "999 999",
                },
            ],
        },
        {
            BO: [
                {
                    name: "Bolivia, Plurinational State of",
                    dial_code: "+591",
                    code: "BO",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            BN: [
                {
                    name: "Brunei Darussalam",
                    dial_code: "+673",
                    code: "BN",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            CD: [
                {
                    name: "Congo, The Democratic Republic of the",
                    dial_code: "+243",
                    code: "CD",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            CI: [
                {
                    name: "Cote d'Ivoire",
                    dial_code: "+225",
                    code: "CI",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            FK: [
                {
                    name: "Falkland Islands (Malvinas)",
                    dial_code: "+500",
                    code: "FK",
                    phone_numbar: 5,
                    phone_formet: "999 99",
                },
            ],
        },
        {
            GG: [
                {
                    name: "Guernsey",
                    dial_code: "+44",
                    code: "GG",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            VA: [
                {
                    name: "Holy See (Vatican City State)",
                    dial_code: "+379",
                    code: "VA",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            HK: [
                {
                    name: "Hong Kong",
                    dial_code: "+852",
                    code: "HK",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            IR: [
                {
                    name: "Iran, Islamic Republic of",
                    dial_code: "+98",
                    code: "IR",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            IM: [
                {
                    name: "Isle of Man",
                    dial_code: "+44",
                    code: "IM",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            JE: [
                {
                    name: "Jersey",
                    dial_code: "+44",
                    code: "JE",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            KP: [
                {
                    name: "Korea, Democratic People's Republic of",
                    dial_code: "+850",
                    code: "KP",
                    phone_numbar: 10,
                    phone_formet: "999 9999 999",
                },
            ],
        },
        {
            KR: [
                {
                    name: "Korea, Republic of",
                    dial_code: "+82",
                    code: "KR",
                    phone_numbar: 11,
                    phone_formet: "999 999 999 99",
                },
            ],
        },
        {
            LA: [
                {
                    name: "Lao People's Democratic Republic",
                    dial_code: "+856",
                    code: "LA",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            LY: [
                {
                    name: "Libyan Arab Jamahiriya",
                    dial_code: "+218",
                    code: "LY",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            MO: [
                {
                    name: "Macao",
                    dial_code: "+853",
                    code: "MO",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            MK: [
                {
                    name: "Macedonia, The Former Yugoslav Republic of",
                    dial_code: "+389",
                    code: "MK",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            FM: [
                {
                    name: "Micronesia, Federated States of",
                    dial_code: "+691",
                    code: "FM",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            MD: [
                {
                    name: "Moldova, Republic of",
                    dial_code: "+373",
                    code: "MD",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            MZ: [
                {
                    name: "Mozambique",
                    dial_code: "+258",
                    code: "MZ",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            PS: [
                {
                    name: "Palestinian Territory, Occupied",
                    dial_code: "+970",
                    code: "PS",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            PN: [
                {
                    name: "Pitcairn",
                    dial_code: "+64",
                    code: "PN",
                    phone_numbar: 13,
                    phone_formet: "99 999 9999 9999",
                },
            ],
        },
        {
            RE: [
                {
                    name: "Réunion",
                    dial_code: "+262",
                    code: "RE",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            RU: [
                {
                    name: "Russia",
                    dial_code: "+7",
                    code: "RU",
                    phone_numbar: 10,
                    phone_formet: "999 9999 999",
                },
            ],
        },
        {
            BL: [
                {
                    name: "Saint Barthélemy",
                    dial_code: "+590",
                    code: "BL",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            SH: [
                {
                    name: "Saint Helena, Ascension and Tristan Da Cunha",
                    dial_code: "+290",
                    code: "SH",
                    phone_numbar: 4,
                    phone_formet: "99 99",
                },
            ],
        },
        {
            KN: [
                {
                    name: "Saint Kitts and Nevis",
                    dial_code: "+1 869",
                    code: "KN",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            LC: [
                {
                    name: "Saint Lucia",
                    dial_code: "+1 758",
                    code: "LC",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            MF: [
                {
                    name: "Saint Martin",
                    dial_code: "+590",
                    code: "MF",
                    phone_numbar: 10,
                    phone_formet: "999 9999 999",
                },
            ],
        },
        {
            PM: [
                {
                    name: "Saint Pierre and Miquelon",
                    dial_code: "+508",
                    code: "PM",
                    phone_numbar: 6,
                    phone_formet: "999 999",
                },
            ],
        },
        {
            VC: [
                {
                    name: "Saint Vincent and the Grenadines",
                    dial_code: "+1 784",
                    code: "VC",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            ST: [
                {
                    name: "Sao Tome and Principe",
                    dial_code: "+239",
                    code: "ST",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            SO: [
                {
                    name: "Somalia",
                    dial_code: "+252",
                    code: "SO",
                    phone_numbar: 8,
                    phone_formet: "9999 9999",
                },
            ],
        },
        {
            SJ: [
                {
                    name: "Svalbard and Jan Mayen",
                    dial_code: "+47",
                    code: "SJ",
                    phone_numbar: 12,
                    phone_formet: "999 999 999 999",
                },
            ],
        },
        {
            SY: [
                {
                    name: "Syrian Arab Republic",
                    dial_code: "+963",
                    code: "",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            TW: [
                {
                    name: "Taiwan, Province of China",
                    dial_code: "+886",
                    code: "TW",
                    phone_numbar: 10,
                    phone_formet: "999 999 9999",
                },
            ],
        },
        {
            TZ: [
                {
                    name: "Tanzania, United Republic of",
                    dial_code: "+255",
                    code: "TZ",
                    phone_numbar: 9,
                    phone_formet: "999 999 999",
                },
            ],
        },
        {
            TL: [
                {
                    name: "Timor-Leste",
                    dial_code: "+670",
                    code: "TL",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            VE: [
                {
                    name: "Venezuela, Bolivarian Republic of",
                    dial_code: "+58",
                    code: "VE",
                    phone_numbar: 10,
                    phone_formet: "999 9999 999",
                },
            ],
        },
        {
            VN: [
                {
                    name: "Viet Nam",
                    dial_code: "+84",
                    code: "VN",
                    phone_numbar: 10,
                    phone_formet: "999 9999 999",
                },
            ],
        },
        {
            VG: [
                {
                    name: "Virgin Islands, British",
                    dial_code: "+1 284",
                    code: "VG",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
        {
            VI: [
                {
                    name: "Virgin Islands, U.S.",
                    dial_code: "+1 340",
                    code: "VI",
                    phone_numbar: 7,
                    phone_formet: "999 9999",
                },
            ],
        },
    ];
    return jsonFormat;
};

window.getValue = function (key, array) {
    for (var el in array) {
        if (array[el].hasOwnProperty(key)) {
            return array[el][key];
        }
    }
};
window.getTimeZoneJson = function () {
    return {
        BD: [{ tzid: "Asia/Dhaka", name: "Bangladesh" }],
        BE: [{ tzid: "Europe/Brussels", name: "Romance" }],
        BF: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        BG: [{ tzid: "Europe/Sofia", name: "FLE" }],
        BA: [{ tzid: "Europe/Belgrade", name: "Central Europe" }],
        BB: [{ tzid: "America/Barbados", name: "SA Western" }],
        WF: [{ tzid: "Pacific/Wallis", name: "UTC+12" }],
        BL: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        BM: [{ tzid: "Atlantic/Bermuda", name: "Atlantic" }],
        BN: [{ tzid: "Asia/Brunei", name: "Singapore" }],
        BO: [{ tzid: "America/La_Paz", name: "SA Western" }],
        JP: [{ tzid: "Asia/Tokyo", name: "Tokyo" }],
        BI: [{ tzid: "Africa/Maputo", name: "South Africa" }],
        BJ: [{ tzid: "Africa/Lagos", name: "W. Central Africa" }],
        BT: [{ tzid: "Asia/Thimphu", name: "Bangladesh" }],
        JM: [{ tzid: "America/Jamaica", name: "SA Pacific" }],
        JO: [{ tzid: "Asia/Amman", name: "Jordan" }],
        WS: [{ tzid: "Pacific/Apia", name: "Samoa" }],
        BQ: [{ tzid: "America/Curacao", name: "SA Western" }],
        BR: [
            { tzid: "America/Noronha", name: "UTC-02" },
            {
                tzid: "America/Belem",
                name: "Belem",
            },
            { tzid: "America/Fortaleza", name: "Fortaleza" },
            {
                tzid: "America/Recife",
                name: "Recife",
            },
            { tzid: "America/Araguaina", name: "Araguaina" },
            {
                tzid: "America/Maceio",
                name: "Maceio",
            },
            { tzid: "America/Bahia", name: "Bahia" },
            {
                tzid: "America/Sao_Paulo",
                name: "Sao Paulo",
            },
            { tzid: "America/Campo_Grande", name: "Campo Grande" },
            {
                tzid: "America/Cuiaba",
                name: "Cuiaba",
            },
            { tzid: "America/Porto_Velho", name: "Velho" },
            {
                tzid: "America/Boa_Vista",
                name: "Boa Vista",
            },
            { tzid: "America/Manaus", name: "Manaus" },
            { tzid: "America/Rio_Branco", name: "Rio Branco" },
        ],
        BS: [{ tzid: "America/Nassau", name: "Eastern" }],
        JE: [{ tzid: "Europe/London", name: "GMT" }],
        BY: [{ tzid: "Europe/Minsk", name: "Belarus" }],
        BZ: [{ tzid: "America/Belize", name: "Central America" }],
        RU: [
            { tzid: "Europe/Kaliningrad", name: "Kaliningrad" },
            {
                tzid: "Europe/Moscow",
                name: "Russian",
            },
            { tzid: "Europe/Simferopol", name: "Russian" },
            {
                tzid: "Europe/Volgograd",
                name: "Russian",
            },
            { tzid: "Europe/Samara", name: "Russia Zone 3" },
            {
                tzid: "Asia/Yekaterinburg",
                name: "Ekaterinburg",
            },
            { tzid: "Asia/Omsk", name: "N. Central Asia" },
            {
                tzid: "Asia/Novosibirsk",
                name: "N. Central Asia",
            },
            { tzid: "Asia/Novokuznetsk", name: "North Asia" },
            {
                tzid: "Asia/Krasnoyarsk",
                name: "North Asia",
            },
            { tzid: "Asia/Irkutsk", name: "North Asia East" },
            {
                tzid: "Asia/Chita",
                name: "Yakutsk",
            },
            { tzid: "Asia/Yakutsk", name: "Yakutsk" },
            {
                tzid: "Asia/Khandyga",
                name: "Yakutsk",
            },
            { tzid: "Asia/Vladivostok", name: "Vladivostok" },
            {
                tzid: "Asia/Ust-Nera",
                name: "Vladivostok",
            },
            { tzid: "Asia/Magadan", name: "Magadan" },
            {
                tzid: "Asia/Sakhalin",
                name: "Vladivostok",
            },
            { tzid: "Asia/Srednekolymsk", name: "Russia Zone 10" },
            {
                tzid: "Asia/Kamchatka",
                name: "Russia Zone 11",
            },
            { tzid: "Asia/Anadyr", name: "Russia Zone 11" },
        ],
        RW: [{ tzid: "Africa/Maputo", name: "South Africa" }],
        RS: [{ tzid: "Europe/Belgrade", name: "Central Europe" }],
        LT: [{ tzid: "Europe/Vilnius", name: "FLE" }],
        RE: [{ tzid: "Indian/Reunion", name: "Mauritius" }],
        LU: [{ tzid: "Europe/Luxembourg", name: "W. Europe" }],
        LR: [{ tzid: "Africa/Monrovia", name: "Greenwich" }],
        RO: [{ tzid: "Europe/Bucharest", name: "GTB" }],
        TK: [{ tzid: "Pacific/Fakaofo", name: "Tonga" }],
        GW: [{ tzid: "Africa/Bissau", name: "Greenwich" }],
        GU: [{ tzid: "Pacific/Guam", name: "West Pacific" }],
        GT: [{ tzid: "America/Guatemala", name: "Central America" }],
        GR: [{ tzid: "Europe/Athens", name: "GTB" }],
        GQ: [{ tzid: "Africa/Lagos", name: "W. Central Africa" }],
        GP: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        BH: [{ tzid: "Asia/Qatar", name: "Arab" }],
        GY: [{ tzid: "America/Guyana", name: "SA Western" }],
        GG: [{ tzid: "Europe/London", name: "GMT" }],
        GF: [{ tzid: "America/Cayenne", name: "SA Eastern" }],
        GE: [{ tzid: "Asia/Tbilisi", name: "Georgian" }],
        GD: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        GB: [{ tzid: "Europe/London", name: "GMT" }],
        GA: [{ tzid: "Africa/Lagos", name: "W. Central Africa" }],
        GN: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        GM: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        GL: [
            { tzid: "America/Godthab", name: "Greenland" },
            {
                tzid: "America/Danmarkshavn",
                name: "UTC",
            },
            { tzid: "America/Scoresbysund", name: "Azores" },
            { tzid: "America/Thule", name: "Atlantic" },
        ],
        GI: [{ tzid: "Europe/Gibraltar", name: "W. Europe" }],
        GH: [{ tzid: "Africa/Accra", name: "Greenwich" }],
        OM: [{ tzid: "Asia/Dubai", name: "Arabian" }],
        BW: [{ tzid: "Africa/Maputo", name: "South Africa" }],
        HR: [{ tzid: "Europe/Belgrade", name: "Central Europe" }],
        HT: [{ tzid: "America/Port-au-Prince", name: "Eastern" }],
        HU: [{ tzid: "Europe/Budapest", name: "Central Europe" }],
        HK: [{ tzid: "Asia/Hong_Kong", name: "China" }],
        HN: [{ tzid: "America/Tegucigalpa", name: "Central America" }],
        LV: [{ tzid: "Europe/Riga", name: "FLE" }],
        AD: [{ tzid: "Europe/Andorra", name: "W. Europe" }],
        PR: [{ tzid: "America/Puerto_Rico", name: "SA Western" }],
        PS: [{ tzid: "Asia/Gaza", name: "Palestine Time" }],
        PW: [{ tzid: "Pacific/Palau", name: "Tokyo" }],
        PT: [
            { tzid: "Europe/Lisbon", name: "Lisbon" },
            { tzid: "Atlantic/Azores", name: "Azores" },
        ],
        KR: [{ tzid: "Asia/Seoul", name: "Korea" }],
        PY: [{ tzid: "America/Asuncion", name: "Paraguay" }],
        IQ: [{ tzid: "Asia/Baghdad", name: "Arabic" }],
        PA: [{ tzid: "America/Panama", name: "SA Pacific" }],
        PF: [{ tzid: "Pacific/Tahiti", name: "Hawaiian" }],
        PG: [
            { tzid: "Pacific/Port_Moresby", name: "West Pacific" },
            {
                tzid: "Pacific/Bougainville",
                name: "Central Pacific",
            },
        ],
        PE: [{ tzid: "America/Lima", name: "SA Pacific" }],
        PK: [{ tzid: "Asia/Karachi", name: "Pakistan" }],
        PH: [{ tzid: "Asia/Manila", name: "Singapore" }],
        PN: [{ tzid: "Pacific/Pitcairn", name: "Pitcairn Time" }],
        PL: [{ tzid: "Europe/Warsaw", name: "Central European" }],
        PM: [{ tzid: "America/Miquelon", name: "Miquelon Time" }],
        ZM: [{ tzid: "Africa/Maputo", name: "South Africa" }],
        EH: [{ tzid: "Africa/El_Aaiun", name: "Morocco" }],
        EE: [{ tzid: "Europe/Tallinn", name: "FLE" }],
        EG: [{ tzid: "Africa/Cairo", name: "Egypt" }],
        ZA: [{ tzid: "Africa/Johannesburg", name: "South Africa" }],
        EC: [
            { tzid: "America/Guayaquil", name: "SA Pacific" },
            {
                tzid: "Pacific/Galapagos",
                name: "Central America",
            },
        ],
        AL: [{ tzid: "Europe/Tirane", name: "Central Europe" }],
        AO: [{ tzid: "Africa/Lagos", name: "W. Central Africa" }],
        KZ: [
            { tzid: "Asia/Almaty", name: "Almaty" },
            {
                tzid: "Asia/Aqtobe",
                name: "Aqtobe",
            },
            { tzid: "Asia/Aqtau", name: "Aqtau" },
        ],
        ET: [{ tzid: "Africa/Nairobi", name: "E. Africa" }],
        SO: [{ tzid: "Africa/Nairobi", name: "E. Africa" }],
        ZW: [{ tzid: "Africa/Maputo", name: "South Africa" }],
        KY: [{ tzid: "America/Panama", name: "SA Pacific" }],
        ES: [
            { tzid: "Europe/Madrid", name: "Madrid" },
            {
                tzid: "Africa/Ceuta",
                name: "Ceuta",
            },
            { tzid: "Atlantic/Canary", name: "GMT" },
        ],
        ER: [{ tzid: "Africa/Nairobi", name: "E. Africa" }],
        ME: [{ tzid: "Europe/Belgrade", name: "Central Europe" }],
        MD: [{ tzid: "Europe/Chisinau", name: "E. Europe" }],
        MG: [{ tzid: "Africa/Nairobi", name: "E. Africa" }],
        MF: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        MA: [{ tzid: "Africa/Casablanca", name: "Morocco" }],
        MC: [{ tzid: "Europe/Monaco", name: "W. Europe" }],
        UZ: [{ tzid: "Asia/Tashkent", name: "Tashkent" }],
        MM: [{ tzid: "Asia/Rangoon", name: "Myanmar" }],
        ML: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        MO: [{ tzid: "Asia/Macau", name: "China" }],
        MN: [
            { tzid: "Asia/Ulaanbaatar", name: "Ulaanbaatar" },
            { tzid: "Asia/Choibalsan", name: "Choibalsan" },
        ],
        MH: [
            { tzid: "Pacific/Majuro", name: "Majuro" },
            { tzid: "Pacific/Kwajalein", name: "Kwajalein" },
        ],
        MK: [{ tzid: "Europe/Belgrade", name: "Central Europe" }],
        UM: [
            { tzid: "Pacific/Pago_Pago", name: "UTC-11" },
            {
                tzid: "Pacific/Wake",
                name: "UTC+12",
            },
            { tzid: "Pacific/Honolulu", name: "Hawaiian" },
        ],
        MT: [{ tzid: "Europe/Malta", name: "W. Europe" }],
        MW: [{ tzid: "Africa/Maputo", name: "South Africa" }],
        MV: [{ tzid: "Indian/Maldives", name: "West Asia" }],
        MQ: [{ tzid: "America/Martinique", name: "SA Western" }],
        MP: [{ tzid: "Pacific/Guam", name: "West Pacific" }],
        MS: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        MR: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        AU: [
            { tzid: "Antarctica/Macquarie", name: "Central Pacific" },
            {
                tzid: "Australia/Hobart",
                name: "Eastern - Hobart",
            },
            { tzid: "Australia/Sydney", name: "Eastern - Sydney" },
            {
                tzid: "Australia/Brisbane",
                name: "Eastern - Brisbane",
            },
            { tzid: "Australia/Adelaide", name: "Central- Adelaide" },
            {
                tzid: "Australia/Darwin",
                name: "Central - Darwin",
            },
            { tzid: "Australia/Perth", name: "Western" },
        ],
        UG: [{ tzid: "Africa/Nairobi", name: "E. Africa" }],
        MY: [{ tzid: "Asia/Kuala_Lumpur", name: "Kuala Lumpur" }],
        MX: [
            { tzid: "America/Mexico_City", name: "Central - Mexico City" },
            {
                tzid: "America/Cancun",
                name: "Eastern",
            },
            { tzid: "America/Chihuahua", name: "Mountain - Chihuahua" },
            {
                tzid: "America/Hermosillo",
                name: "Mountain - Hermosillo",
            },
            { tzid: "America/Tijuana", name: "Pacific" },
        ],
        VU: [{ tzid: "Pacific/Efate", name: "Central Pacific" }],
        FR: [{ tzid: "Europe/Paris", name: "Romance" }],
        AW: [{ tzid: "America/Curacao", name: "SA Western" }],
        SH: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        AF: [{ tzid: "Asia/Kabul", name: "Afghanistan" }],
        AX: [{ tzid: "Europe/Helsinki", name: "FLE" }],
        FI: [{ tzid: "Europe/Helsinki", name: "FLE" }],
        FJ: [{ tzid: "Pacific/Fiji", name: "Fiji" }],
        FK: [{ tzid: "Atlantic/Stanley", name: "SA Eastern" }],
        FM: [{ tzid: "Pacific/Kosrae", name: "Central Pacific" }],
        FO: [{ tzid: "Atlantic/Faroe", name: "Faroe Time" }],
        NI: [{ tzid: "America/Managua", name: "Central America" }],
        NL: [{ tzid: "Europe/Amsterdam", name: "W. Europe" }],
        NO: [{ tzid: "Europe/Oslo", name: "W. Europe" }],
        NA: [{ tzid: "Africa/Windhoek", name: "Namibia" }],
        NC: [{ tzid: "Pacific/Noumea", name: "Central Pacific" }],
        NE: [{ tzid: "Africa/Lagos", name: "W. Central Africa" }],
        NF: [{ tzid: "Pacific/Norfolk", name: "Central Pacific" }],
        NG: [{ tzid: "Africa/Lagos", name: "W. Central Africa" }],
        NZ: [{ tzid: "Pacific/Auckland", name: "New Zealand" }],
        NP: [{ tzid: "Asia/Kathmandu", name: "Nepal Time" }],
        NR: [{ tzid: "Pacific/Nauru", name: "UTC+12" }],
        NU: [{ tzid: "Pacific/Niue", name: "UTC-11" }],
        CK: [{ tzid: "Pacific/Rarotonga", name: "Hawaiian" }],
        CI: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        CH: [{ tzid: "Europe/Zurich", name: "W. Europe" }],
        CO: [{ tzid: "America/Bogota", name: "SA Pacific" }],
        CN: [
            { tzid: "Asia/Shanghai", name: "China" },
            { tzid: "Asia/Urumqi", name: "Central Asia" },
        ],
        CM: [{ tzid: "Africa/Lagos", name: "W. Central Africa" }],
        CL: [
            { tzid: "America/Santiago", name: "Santiago" },
            { tzid: "Pacific/Easter", name: "Easter Island" },
        ],
        CC: [{ tzid: "Indian/Cocos", name: "Myanmar" }],
        CA: [
            { tzid: "America/St_Johns", name: "Newfoundland" },
            {
                tzid: "America/Halifax",
                name: "Atlantic - Halifax",
            },
            { tzid: "America/Toronto", name: "Eastern - Toronto" },
            {
                tzid: "America/Iqaluit",
                name: "Eastern - Iqaluit",
            },
            { tzid: "America/Winnipeg", name: "Central - Winnipeg" },
            {
                tzid: "America/Regina",
                name: "Central - Regina",
            },
            { tzid: "America/Edmonton", name: "Mountain - Edmonton" },
            {
                tzid: "America/Yellowknife",
                name: "Mountain - Yellowknife",
            },
            { tzid: "America/Dawson_Creek", name: "Dawson Creek" },
            {
                tzid: "America/Vancouver",
                name: "Pacific - Vancouver",
            },
            { tzid: "America/Whitehorse", name: "Pacific - Whitehorse" },
        ],
        CG: [{ tzid: "Africa/Lagos", name: "W. Central Africa" }],
        CF: [{ tzid: "Africa/Lagos", name: "W. Central Africa" }],
        CD: [
            { tzid: "Africa/Maputo", name: "South Africa" },
            {
                tzid: "Africa/Lagos",
                name: "W. Central Africa",
            },
        ],
        CZ: [{ tzid: "Europe/Prague", name: "Central Europe" }],
        CY: [{ tzid: "Asia/Nicosia", name: "GTB" }],
        CX: [{ tzid: "Indian/Christmas", name: "SE Asia" }],
        CR: [{ tzid: "America/Costa_Rica", name: "Central America" }],
        CW: [{ tzid: "America/Curacao", name: "SA Western" }],
        CV: [{ tzid: "Atlantic/Cape_Verde", name: "Cape Verde" }],
        CU: [{ tzid: "America/Havana", name: "Eastern" }],
        SZ: [{ tzid: "Africa/Johannesburg", name: "South Africa" }],
        SY: [{ tzid: "Asia/Damascus", name: "Syria" }],
        SX: [{ tzid: "America/Curacao", name: "SA Western" }],
        KG: [{ tzid: "Asia/Bishkek", name: "Central Asia" }],
        KE: [{ tzid: "Africa/Nairobi", name: "E. Africa" }],
        SS: [{ tzid: "Africa/Khartoum", name: "E. Africa" }],
        SR: [{ tzid: "America/Paramaribo", name: "SA Eastern" }],
        KI: [
            { tzid: "Pacific/Tarawa", name: "UTC+12" },
            {
                tzid: "Pacific/Enderbury",
                name: "Tonga",
            },
            { tzid: "Pacific/Kiritimati", name: "Line Islands" },
        ],
        KH: [{ tzid: "Asia/Bangkok", name: "SE Asia" }],
        SV: [{ tzid: "America/El_Salvador", name: "Central America" }],
        KM: [{ tzid: "Africa/Nairobi", name: "E. Africa" }],
        ST: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        SK: [{ tzid: "Europe/Prague", name: "Central Europe" }],
        SJ: [{ tzid: "Europe/Oslo", name: "W. Europe" }],
        SI: [{ tzid: "Europe/Belgrade", name: "Central Europe" }],
        KP: [{ tzid: "Asia/Pyongyang", name: "North Korea" }],
        KW: [{ tzid: "Asia/Riyadh", name: "Arab" }],
        SN: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        SM: [{ tzid: "Europe/Rome", name: "W. Europe" }],
        SL: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        SC: [{ tzid: "Indian/Mahe", name: "Mauritius" }],
        SB: [{ tzid: "Pacific/Guadalcanal", name: "Central Pacific" }],
        SA: [{ tzid: "Asia/Riyadh", name: "Arab" }],
        SG: [{ tzid: "Asia/Singapore", name: "Singapore" }],
        SE: [{ tzid: "Europe/Stockholm", name: "W. Europe" }],
        SD: [{ tzid: "Africa/Khartoum", name: "E. Africa" }],
        DO: [{ tzid: "America/Santo_Domingo", name: "SA Western" }],
        DM: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        DJ: [{ tzid: "Africa/Nairobi", name: "E. Africa" }],
        DK: [{ tzid: "Europe/Copenhagen", name: "Romance" }],
        DE: [{ tzid: "Europe/Berlin", name: "Berlin" }],
        YE: [{ tzid: "Asia/Riyadh", name: "Arab" }],
        AT: [{ tzid: "Europe/Vienna", name: "W. Europe" }],
        DZ: [{ tzid: "Africa/Algiers", name: "W. Central Africa" }],
        US: [
            { tzid: "America/New_York", name: "Eastern" },
            {
                tzid: "America/Chicago",
                name: "Central",
            },
            { tzid: "America/Denver", name: "Mountain" },
            {
                tzid: "America/Phoenix",
                name: "Mountain - AZ",
            },
            { tzid: "America/Los_Angeles", name: "Pacific" },
            {
                tzid: "America/Anchorage",
                name: "Alaskan",
            },
            { tzid: "Pacific/Honolulu", name: "Hawaiian" },
        ],
        UY: [{ tzid: "America/Montevideo", name: "Montevideo" }],
        YT: [{ tzid: "Africa/Nairobi", name: "E. Africa" }],
        MU: [{ tzid: "Indian/Mauritius", name: "Mauritius" }],
        KN: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        LB: [{ tzid: "Asia/Beirut", name: "Middle East" }],
        LC: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        LA: [{ tzid: "Asia/Bangkok", name: "SE Asia" }],
        TV: [{ tzid: "Pacific/Funafuti", name: "UTC+12" }],
        TW: [{ tzid: "Asia/Taipei", name: "Taipei" }],
        TT: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        TR: [{ tzid: "Europe/Istanbul", name: "Turkey" }],
        LK: [{ tzid: "Asia/Colombo", name: "Sri Lanka" }],
        LI: [{ tzid: "Europe/Zurich", name: "W. Europe" }],
        TN: [{ tzid: "Africa/Tunis", name: "W. Central Africa" }],
        TO: [{ tzid: "Pacific/Tongatapu", name: "Tonga" }],
        TL: [{ tzid: "Asia/Dili", name: "Tokyo" }],
        TM: [{ tzid: "Asia/Ashgabat", name: "West Asia" }],
        TJ: [{ tzid: "Asia/Dushanbe", name: "West Asia" }],
        LS: [{ tzid: "Africa/Johannesburg", name: "South Africa" }],
        TH: [{ tzid: "Asia/Bangkok", name: "SE Asia" }],
        TG: [{ tzid: "Africa/Abidjan", name: "Greenwich" }],
        TD: [{ tzid: "Africa/Ndjamena", name: "W. Central Africa" }],
        TC: [{ tzid: "America/Grand_Turk", name: "SA Western" }],
        LY: [{ tzid: "Africa/Tripoli", name: "Libya" }],
        VA: [{ tzid: "Europe/Rome", name: "W. Europe" }],
        VC: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        AE: [{ tzid: "Asia/Dubai", name: "Arabian" }],
        VE: [{ tzid: "America/Caracas", name: "Venezuela" }],
        AG: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        VG: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        AI: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        VI: [{ tzid: "America/Port_of_Spain", name: "SA Western" }],
        IS: [{ tzid: "Atlantic/Reykjavik", name: "Greenwich" }],
        IR: [{ tzid: "Asia/Tehran", name: "Iran" }],
        AM: [{ tzid: "Asia/Yerevan", name: "Caucasus" }],
        IT: [{ tzid: "Europe/Rome", name: "W. Europe" }],
        VN: [{ tzid: "Asia/Bangkok", name: "SE Asia" }],
        AS: [{ tzid: "Pacific/Pago_Pago", name: "UTC-11" }],
        AR: [{ tzid: "America/Argentina/Salta", name: "Argentina" }],
        IM: [{ tzid: "Europe/London", name: "GMT" }],
        IL: [{ tzid: "Asia/Jerusalem", name: "Israel" }],
        IO: [{ tzid: "Indian/Chagos", name: "Central Asia" }],
        IN: [{ tzid: "Asia/Kolkata", name: "India" }],
        TZ: [{ tzid: "Africa/Nairobi", name: "E. Africa" }],
        AZ: [{ tzid: "Asia/Baku", name: "Azerbaijan" }],
        IE: [{ tzid: "Europe/Dublin", name: "GMT" }],
        ID: [
            { tzid: "Asia/Jakarta", name: "Jakarta" },
            {
                tzid: "Asia/Makassar",
                name: "Singapore",
            },
            { tzid: "Asia/Jayapura", name: "Tokyo" },
        ],
        UA: [{ tzid: "Europe/Kiev", name: "Kiev" }],
        QA: [{ tzid: "Asia/Qatar", name: "Arab" }],
        MZ: [{ tzid: "Africa/Maputo", name: "South Africa" }],
    };
};

window.limitCountCharForText = function (element, count) {
    var len = element.value.length;
    if (len >= count) {
        element.value = element.value.substring(0, count);
    } else {
        var remaining = count - len;
        console.log("limitCountCharForText", remaining);
        $(element)
            .closest(".form-group")
            .find(".limit_count_number_bio")
            .text(remaining + " characters left");
    }
};

window.formatNumber = function (n) {
    // format number 1000000 to 1,234,567
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, "");
};

window.formatCurrency = function (input, blur) {
    // appends $ to value, validates decimal side
    // and puts cursor back in right position.

    // get input value
    var input_val = input.val();

    // don't validate empty input
    if (input_val === "") {
        return;
    }

    // initial caret/selection position
    var caret_pos = input.prop("selectionStart");
    var sel_end = input.prop("selectionEnd");

    // Preserve native browser keyboard shortcuts: when the user has an
    // active selection (e.g. just pressed Ctrl/Cmd+A), don't rewrite the
    // value and don't collapse the selection. See design system §16.5.2
    // "Native Browser Shortcuts in Form Inputs".
    if (blur !== "blur" && caret_pos !== sel_end) {
        return;
    }

    // original length
    var original_len = input_val.length;

    // check for decimal
    if (input_val.indexOf(".") >= 0) {
        // get position of first decimal
        // this prevents multiple decimals from
        // being entered
        var decimal_pos = input_val.indexOf(".");

        // split number by decimal point
        var left_side = input_val.substring(0, decimal_pos);
        var right_side = input_val.substring(decimal_pos);

        // add commas to left side of number
        left_side = formatNumber(left_side);

        // validate right side
        right_side = formatNumber(right_side);

        // On blur make sure 2 numbers after decimal
        if (blur === "blur") {
            right_side += "00";
        }

        // Limit decimal to only 2 digits
        right_side = right_side.substring(0, 2);

        // join number by .
        input_val = "$" + left_side + "." + right_side;
    } else {
        // no decimal entered
        // add commas to number
        // remove all non-digits
        input_val = formatNumber(input_val);
        input_val = "$" + input_val;

        // final formatting
        if (blur === "blur") {
            input_val += ".00";
        }
    }

    // send updated string to input
    input.val(input_val);

    // put caret back in the right position
    var updated_len = input_val.length;
    caret_pos = updated_len - original_len + caret_pos;
    input[0].setSelectionRange(caret_pos, caret_pos);
};

window.uploadCropImage = function (changeImageProfileCurrent) {
    if (changeImageProfileCurrent == undefined) {
        changeImageProfileCurrent = true;
    }
    var avatarCropFiles = [];
    var $modal = $("#modal_crop_image_avatar");
    var imageAvatar = document.getElementById("crop_image");
    var cropper;
    var range_ratio_value;

    var $modalCropImageAvatar = $("#modal_crop_image_avatar");
    $("#upload").change(function (event) {
        $(".error_LogoDetailsImage_avtar").html("");
        $(".error_LogoDetailsImage_avtar").text("");
        const file = this.files[0];

        if (!file) return;

        // Check file size
        if (file.size > 5000000) {
            $(".error_LogoDetailsImage_avtar").html(
                "Maximum image size is 5MB. "
                + "To reduce your image, try a free service like <a target='_blank' href='https://www.simpleimageresizer.com' class='text-muted text-decoration-underline' style='text-decoration: underline;'>this one</a>");
            return false;
        }

        // Check file type
        if (!file.type.startsWith('image/')) {
            $(".error_LogoDetailsImage_avtar").html("Please select an image file");
            return false;
        }

        let reader = new FileReader();
        reader.onload = function (event) {
            // Create a new image to check dimensions
            const img = new Image();
            img.onload = function() {
                // Set initial preview
                $("#user_profile").attr("src", event.target.result);
                $("img.image-avatar-profile").attr("src", event.target.result);
                if (changeImageProfileCurrent) {
                    $("#header_profile_img").attr("src", event.target.result);
                }
                $(".remove_image").show();

                // Initialize cropper
                imageAvatar.src = event.target.result;
                $modalCropImageAvatar.modal("show");
            };
            img.src = event.target.result;
        };
        reader.readAsDataURL(file);
    });

    $modal
        .on("shown.bs.modal", function () {
            setTimeout(function () {
                // Destroy existing cropper if any
                if (cropper) {
                    cropper.destroy();
                    cropper = null;
                }

                // Initialize new cropper with improved settings
                cropper = new Cropper(imageAvatar, {
                    aspectRatio: 1,
                    viewMode: 2,
                    guides: true,
                    dragMode: "move",
                    movable: true,
                    cropBoxMovable: true,
                    cropBoxResizable: true,
                    // Spec section13_user-onboarding/design.md L1257-1259:
                    //   min_dimensions: 200x200px, max_dimensions: 2000x2000px
                    minCropBoxWidth: 200,
                    minCropBoxHeight: 200,
                    zoomOnWheel: true,
                    autoCropArea: 0.8,
                    restore: false,
                    responsive: true,
                    checkOrientation: true,
                    ready: function (e) {
                        range_ratio_value = jQuery("#range_ratio_value");
                        
                        // Initialize zoom slider
                        jQuery("#zoom-slider").slider({
                            min: 0.1,
                            max: 4,
                            value: 1,
                            step: 0.1,
                            slide: function (event, ui) {
                                if (cropper) {
                                    cropper.zoomTo(ui.value);
                                    range_ratio_value.val(ui.value);
                                }
                            }
                        });
                    }
                });
            }, 100);
        })
        .on("hidden.bs.modal", function () {
            if (cropper) {
                cropper.destroy();
                cropper = null;
            }
        });

    $("#crop").click(function () {
        if (!cropper) return;

        // Get cropped canvas with proper dimensions and quality
        // Spec section13_user-onboarding/design.md L1260:
        //   processing: generate_3_sizes (50x50, 200x200, 500x500)
        // Cap the exported canvas at the largest stored size so we never
        // upscale a tight selection (which would add blur), and so output
        // file size stays within the 1MB limit (L1256).
        canvas = cropper.getCroppedCanvas({
            maxWidth: 500,
            maxHeight: 500,
            imageSmoothingEnabled: true,
            imageSmoothingQuality: 'high'
        });

        // Convert to blob with proper quality
        canvas.toBlob(function (blob) {
            if (!blob) return;

            const url = URL.createObjectURL(blob);
            const reader = new FileReader();
            
            reader.onloadend = function () {
                const base64data = reader.result;
                $("#user_profile").attr("src", base64data);
                $("img.image-avatar-profile").attr("src", base64data);
                if (changeImageProfileCurrent) {
                    $("#header_profile_img").attr("src", base64data);
                }
                
                avatarCropFiles = base64data;
                $("#result_image_file").val(base64data);
                
                $modal.modal("hide");
                $(".remove_image").removeClass("d-none-remove-image");
            };
            
            reader.readAsDataURL(blob);
        }, 'image/jpeg', 0.9); // Use JPEG with 90% quality
    });

    $(".remove_image").click(function () {
        var currentUrl = window.location.pathname; // this is wrong, because it include domain, only get path
        $("#user_profile").attr(
            "src",
            "https://secure.gravatar.com/avatar/2a34706e768f6723ef04a831eedc3b34?s=64&d=mm&r=g",
        );
        const notActionUrls = ["/create-account-for-child"];
        $("img.image-avatar-profile").attr(
            "src",
            "https://secure.gravatar.com/avatar/2a34706e768f6723ef04a831eedc3b34?s=64&d=mm&r=g",
        );
        if (!notActionUrls.includes(currentUrl)) {
            $("#header_profile_img").attr(
                "src",
                "https://secure.gravatar.com/avatar/2a34706e768f6723ef04a831eedc3b34?s=64&d=mm&r=g",
            );
         }

        $("#upload").val("");
        $("#result_image_file").val("");
        $(this).hide();
    });

    $("#wizard_start_2_inner #user_profile").on("click", function () {
        $("#upload").trigger("click");
    });
};

window.underAgeValidate = function (birthday) {
    var optimizedBirthday = birthday.replace(/-/g, "/");
    var myBirthday = new Date(optimizedBirthday);
    var currentDate = new Date().toJSON().slice(0, 10) + " 01:00:00";
    var myAge = ~~((Date.now(currentDate) - myBirthday) / 31557600000);
    if (myAge < 13) {
        return false;
    } else {
        return true;
    }
};
window.underAgeValidateYounger = function (birthday) {
    var optimizedBirthday = birthday.replace(/-/g, "/");
    var myBirthday = new Date(optimizedBirthday);
    var currentDate = new Date().toJSON().slice(0, 10) + " 01:00:00";
    var myAge = ~~((Date.now(currentDate) - myBirthday) / 31557600000);
    if (myAge < 18) {
        return false;
    } else {
        return true;
    }
};

window.overAgeValidate = function (birthday) {
    var optimizedBirthday = birthday.replace(/-/g, "/");
    var myBirthday = new Date(optimizedBirthday);
    var currentDate = new Date().toJSON().slice(0, 10) + " 01:00:00";
    var myAge = ~~((Date.now(currentDate) - myBirthday) / 31557600000);
    if (myAge > 70) {
        return false;
    } else {
        return true;
    }
};
window.overAgeValidateYounger = function (birthday) {
    var optimizedBirthday = birthday.replace(/-/g, "/");
    var myBirthday = new Date(optimizedBirthday);
    var currentDate = new Date().toJSON().slice(0, 10) + " 01:00:00";
    var myAge = ~~((Date.now(currentDate) - myBirthday) / 31557600000);
    if (myAge >= 18) {
        return false;
    } else {
        return true;
    }
};

window.validateBirthday = function (birthday) {
    var optimizedBirthday = birthday.replace(/-/g, "/");
    var myBirthday = new Date(optimizedBirthday);
    var currentDate = new Date().toJSON().slice(0, 10) + " 01:00:00";
    var myAge = ~~((Date.now(currentDate) - myBirthday) / 31557600000);
    console.log("myAge", myAge);
    if (myAge > 0) {
        return true;
    } else {
        return false;
    }
};

window.showAlert = function (text, buttonText, callback) {
    swal({
        title: "",
        text: text,
        // icon: "/assets/frontend/images/logo_2.png",
        icon: "/assets/frontend/images/Logov2.png",
        className: "swal-show-alert",
        button: {
            text: buttonText,
        },
    }).then(() => {
        if (callback) {
            callback();
        }
    });
};

window.uploadCertificate = function () {
    Dropzone.autoDiscover = false;
    var token = $('meta[name="csrf-token"]').attr("content");
    // Spec section13_user-onboarding/design.md L661: "Max 5 files, 2MB each".
    var MAX_CERTIFICATES = 5;
    var myDropzone = new Dropzone("#upload-certificates", {
        url: "/ajax/instructor/setting/upload-certificates?_token=" + token,
        dictDefaultMessage: '<i class="fa fa-plus"></i>',
        dictRemoveFile: '<i class="fa fa-times"></i>',
        dictMaxFilesExceeded:
            "You can upload a maximum of " +
            MAX_CERTIFICATES +
            " certificate files.",
        uploadMultiple: false,
        parallelUploads: MAX_CERTIFICATES,
        paramName: "file",
        maxThumbnailFilesize: 5,
        maxFiles: MAX_CERTIFICATES,
        acceptedFiles: "image/*",
        previewsContainer: "#dropzone-template-preview",
        success: function (file, response) {
            file.previewElement.classList.add("dz-success");
            file["attachment_id"] = response; // push the id for future reference
            var ids = jQuery("#file_certificates").val() + "," + response;
            jQuery("#file_certificates").val(ids);
        },
        error: function (file, response) {
            file.previewElement.classList.add("dz-error");
            var msg =
                response && response.message
                    ? response.message
                    : "Upload failed. Please try again.";
            var errEl = file.previewElement.querySelector(
                "[data-dz-errormessage]"
            );
            if (errEl) {
                errEl.textContent = msg;
            }
        },
        addRemoveLinks: true,
        removedfile: function (file) {
            var file_name = file.name;
            var ids = jQuery("#file_certificates").val();
            ids = ids.replace("," + file_name, "");
            // Handle the case where the removed file was the first entry (no leading comma).
            ids = ids.replace(file_name + ",", "");
            ids = ids.replace(file_name, "");
            jQuery("#file_certificates").val(ids);
            jQuery.ajax({
                type: "POST",
                url:
                    "/ajax/instructor/setting/remove-certificates?_token=" +
                    token,
                data: {
                    file_name: file_name,
                },
                success: function (file, response) {},
            });
            var _ref;
            return (_ref = file.previewElement) != null
                ? _ref.parentNode.removeChild(file.previewElement)
                : void 0;
        },
    });
    // Existing certificates must count toward maxFiles. Dropzone's
    // displayExistingFile() emits "addedfile"/"complete" but does NOT push the
    // mock file into myDropzone.files, and Dropzone's maxFiles check uses
    // getAcceptedFiles() which filters on file.accepted === true. Without
    // marking the mock files accepted+SUCCESS the cap never engages on reload,
    // so a guru with 5 saved certs could re-open the page and add 5 more.
    listImgSrcCertificates.forEach(function (val) {
        myDropzone.displayExistingFile(val, val.url);
        val.accepted = true;
        val.status = Dropzone.SUCCESS;
        myDropzone.files.push(val);
    });
    if (typeof myDropzone._updateMaxFilesReachedClass === "function") {
        myDropzone._updateMaxFilesReachedClass();
    }
};
window.openTabSetting = function (evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
};
window.scrollToTop = function (top) {
    $("html, body").animate({ scrollTop: top }, "slow");
};
window.downloadVideo = function () {
    $(".download_twilio_video").on("click", function () {
        var link = $(this).attr("data-link");
        if (link.length > 0) {
            window.open(link, "_blank");
        } else {
            showAlert(
                "The video is still being composed and is not available for download yet. Please try again later.",
                "Close",
            );
        }
    });
};

window.msToTime = function (duration) {
    var milliseconds = Math.floor((duration % 1000) / 100),
        seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    return hours + " Hours " + minutes + " Minutes";
};
window.getOffsetBetweenTimezonesForDate = function (
    date,
    timezone1,
    timezone2,
) {
    const timezone1Date = convertDateToAnotherTimeZone(date, timezone1);
    const timezone2Date = convertDateToAnotherTimeZone(date, timezone2);
    return timezone1Date.getTime() - timezone2Date.getTime();
};

window.convertDateToAnotherTimeZone = function (date, timezone) {
    const dateString = date.toLocaleString("en-US", {
        timeZone: timezone,
    });
    return new Date(dateString);
};
window.addInstructorFavorite = function () {
    $(document).on("click", ".add_instructor_favorite", function () {
        var instructorId = $(this).data("id");
        var $this = this;
        $.ajax({
            url: "/ajax/add-instructor-favorites",
            data: {
                instructor_id: instructorId,
            },
            method: "POST",
            success: function () {
                showAlert(
                    "The instructor has been added to your favorite successfully.",
                    "OK",
                );
                $($this).addClass("added_favorite");
            },
            error: function (err) {
                if (err.status === 401) {
                    showAlert(
                        "Error. Please login before taking this action.",
                        "Close",
                    );
                } else {
                    showAlert("Error. Please check again.", "Close");
                }
                console.log(err.status);
            },
        });
    });
};

window.removeInstructorFavorite = function () {
    $(document).on("click", ".remove_instructor_favorite", function (e) {
        e.preventDefault();

        var instructorId = $(this).data("id");
        var $this = this;
        swal({
            title: "Are you sure?",
            text: "The guruu will be removed!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, I am sure!",
            cancelButtonText: "No, cancel it!",
            closeOnConfirm: true,
            closeOnCancel: false,
            className: "swal-show-alert",
            buttons: true,
        }).then((isConfirm) => {
            if (isConfirm) {
                loadingBtn($this);
                $.ajax({
                    url: "/ajax/remove-instructor-favorites",
                    data: {
                        instructor_id: instructorId,
                    },
                    method: "POST",

                    success: function (res) {
                        removeLoadingBtn($this, "Remove");
                        $($this).prop("disabled", true);
                        showAlert(
                            "The instructor has been removed to your favorite successfully.",
                            "OK",
                        );
                        resetInstall();
                        loadInstructors();
                    },
                    error: function (err) {
                        removeLoadingBtn($this, "Remove");
                        showAlert("Error", "Close");
                    },
                });
            } else {
                showAlert("Your item is safe :)", "Close");
            }
        });
    });
};

window.matchYoutubeUrl = function (url) {
    var p =
        /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    if (url.match(p)) {
        return url.match(p)[1];
    }
    return false;
};
window.isValidWebUrl = function (userInput) {
    var res = userInput.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
    );
    if (res == null) return false;
    else return true;
};
window.validateTextHtmlShortInfo = function (str) {
    var isHTMLTest = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
    if (isHTMLTest(str)) {
        return true;
    }

    if (isValidWebUrl(str)) {
        return true;
    }

    return false;
};

window.editorSummerNote = function (classs) {
    $(classs).summernote({
        height: 300,
        toolbar: [
            ["style", ["style"]],
            ["font", ["bold", "underline", "clear"]],
            ["fontname", ["fontname"]],
            ["fontsize", ["fontsize"]],
            ["height", ["height"]],
            ["color", ["color"]],
            ["para", ["ul", "ol", "paragraph"]],
            ["table", ["table"]], // ['insert', ['link', 'picture', 'video']],
            // ['view', ['fullscreen', 'codeview', 'help']],
        ],
        lineHeights: [
            "0.2",
            "0.3",
            "0.4",
            "0.5",
            "0.6",
            "0.8",
            "1.0",
            "1.2",
            "1.4",
            "1.5",
            "2.0",
            "3.0",
        ], // fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36', '48' , '64', '82', '150']
        callbacks: {
            onChange: function (contents, $editable) {
                console.log("onChange:", contents, $editable);
                $(classs).val(contents).trigger("change");
            },
        },
    });
};

window.scrollToTopCustom = function (element, distancToTop) {
    var toTop = $(element).offset().top;
    if (distancToTop !== undefined) {
        var total = distancToTop + toTop;
        // $(window).scrollTop(total);
        $("html,body").animate({ scrollTop: total }, 1000);
    } else {
        // $(window).scrollTop($(element).offset().top);
        $("html,body").animate({ scrollTop: toTop }, 1000);
    }
};

window.adjustSliderHeight = function () {
    var maxHeight = 0;
    $(".home-testimonial-item--wrapper").each(function () {
        var itemHeight = $(this).outerHeight();
        if (itemHeight > maxHeight) {
            maxHeight = itemHeight;
        }
    });

    $(".home-testimonial-item--wrapper").css("height", maxHeight + "px");
};

$(document).ready(function () {
    $(window).resize(function () {
        adjustSliderHeight();
    });
});

window.homeTestimonial = function () {
    $(".home-list-testimonial-items").slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
    adjustSliderHeight();
};
window.meetTheTeamListItemsSlider = function () {
    $(".meet-the-team-list-items").slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                },
            },
        ],
    });
    
};
window.homeHowItWorkSlider = function () {
    $(".how-it-work-slider-home").slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false,
                    variableWidth: true
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    variableWidth: true,
                },
            },
        ],
    });
    
};
window.meetSomeGuruuSlider = function () {
    $(".meet-some-guruu-slider-home").slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false,
                    variableWidth: true
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    variableWidth: true,
                },
            },
        ],
    });
    
};
window.meetSomeGuruuSliderBrowserTutor = function () {
    $(".meet-some-guruu-slider-browser-tutor").slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false,
                    variableWidth: true
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,

                },
            },
        ],
    });
    
};
window.closeOpenCollapse = function () {
    $('.accordion .collapse').on('hidden.bs.collapse', function () {
        $(this).closest('.accordion__item').find('.accordion__title').find('.icon-v2').removeClass('icon-minus')
        $(this).closest('.accordion__item').find('.accordion__title').find('.icon-v2').addClass('icon-plus')
    });
    $('.accordion .collapse').on('show.bs.collapse', function () {
        $(this).closest('.accordion__item').find('.accordion__title').find('.icon-v2').addClass('icon-minus')
        $(this).closest('.accordion__item').find('.accordion__title').find('.icon-v2').removeClass('icon-plus')
    });
}

/* ============================================================================
   SPEC-CHANGE-S13-002 — DOB Confirmation Modal helper
   Spec: specs/section13_user-onboarding/design.md §4.4 (subsections 4.4.4–4.4.6).
   Mockup (locked visual): specs/section13_user-onboarding/assets/dob-confirmation-modal-mockup.png.
   Used by: adult signup, guardian signup, guardian-creates-minor (Sections 2/3/4).

   Public API:
       window.GuruuDob.confirmBeforeSubmit({
           form:           jQuery selector or element for the form being gated,
           dobInputName:   name attribute of the DOB input (e.g. 'date_of_birth', 'dob', 'birthday'),
           onConfirm:      function() — called when user clicks "Confirm date of birth".
                           Implementations should perform the actual AJAX submit here.
       });

   Behaviour (per §4.4.6):
   - Reads the DOB value from the form's input, formats YYYY-MM-DD → DD / MM / YYYY for display.
   - Renders the global Guruu "Confirm your date of birth" modal (card EsVuZFu3 / design.md
     "Confirm your date of birth" addendum) via window.showGuruuModal.
   - This modal is a required confirmation: NO X close button, NOT dismissible by
     backdrop click, Escape behaves like "Go back and edit" (never confirms).
   - "Go back and edit" → close, no submission, focus returns to the DOB input.
   - "Confirm and continue" → injects hidden input dob_confirmed=1 into the form, invokes onConfirm().

   Copy override: adult/guardian self-signup uses the addendum copy ("your date of birth").
   Guardian-creates-child flows pass opts.title / opts.bodyLines with child-context wording,
   since "your" would be factually wrong there (spec is silent on the child flow).
   ============================================================================ */
window.GuruuDob = window.GuruuDob || {};

window.GuruuDob.formatDobForDisplay = function (rawValue) {
    if (!rawValue || typeof rawValue !== 'string') {
        return '';
    }
    var iso = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (iso) {
        return iso[3] + ' / ' + iso[2] + ' / ' + iso[1];
    }
    var dmy = rawValue.match(/^(\d{2})[\/\-](\d{2})[\/\-](\d{4})$/);
    if (dmy) {
        return dmy[1] + ' / ' + dmy[2] + ' / ' + dmy[3];
    }
    return rawValue;
};

window.GuruuDob.confirmBeforeSubmit = function (opts) {
    opts = opts || {};
    var $form = $(opts.form);
    var dobInputName = opts.dobInputName || 'date_of_birth';
    var onConfirm = typeof opts.onConfirm === 'function' ? opts.onConfirm : function () {};

    if ($form.length === 0) {
        if (window.console) { console.error('GuruuDob.confirmBeforeSubmit: form not found', opts); }
        return;
    }

    var $dobInput = $form.find('[name="' + dobInputName + '"]');
    if ($dobInput.length === 0) {
        if (window.console) { console.error('GuruuDob.confirmBeforeSubmit: DOB input not found for name=' + dobInputName); }
        return;
    }

    var rawDob = ($dobInput.val() || '').trim();
    if (!rawDob) {
        return;
    }

    // Addendum copy (self-signup default). Child flows override via opts.
    var title = opts.title || 'Confirm your date of birth';
    var bodyLines = opts.bodyLines || [
        'Please confirm that your date of birth is correct.',
        'This is used to determine your access to Guruu and safety features.',
        'Once confirmed, it cannot be changed later.'
    ];

    function focusDob() {
        if ($dobInput.is(':visible') && typeof $dobInput.focus === 'function') {
            $dobInput.focus();
        }
    }

    function confirmDob(closeModal) {
        $form.find('input[name="dob_confirmed"]').remove();
        $('<input>')
            .attr({ type: 'hidden', name: 'dob_confirmed', value: '1' })
            .appendTo($form);

        if (typeof closeModal === 'function') { closeModal(); }
        try {
            onConfirm();
        } catch (err) {
            if (window.console) { console.error('GuruuDob.confirmBeforeSubmit: onConfirm threw', err); }
        }
    }

    if (typeof window.showGuruuModal === 'function') {
        window.showGuruuModal({
            title: title,
            body: bodyLines,
            dateDisplay: window.GuruuDob.formatDobForDisplay(rawDob),
            primaryLabel: 'Confirm and continue',
            secondaryLabel: 'Go back and edit',
            dismissible: false, // no X, no backdrop close; Esc → Go back and edit
            onPrimary: confirmDob,
            onSecondary: function (closeModal) {
                closeModal();
                focusDob();
            },
            onClose: focusDob
        });
        return;
    }

    // Fallback: legacy Bootstrap partial if the global modal host isn't present.
    var $modal = $('#dobConfirmModal');
    if ($modal.length === 0) {
        if (window.console) { console.error('GuruuDob.confirmBeforeSubmit: neither showGuruuModal nor #dobConfirmModal available.'); }
        return;
    }

    $modal.find('[data-dob-confirm-display]').text(window.GuruuDob.formatDobForDisplay(rawDob));

    var $primary = $modal.find('[data-dob-confirm-action="confirm"]');
    var $secondary = $modal.find('[data-dob-confirm-action="back"]');

    $primary.off('click.dobConfirm');
    $secondary.off('click.dobConfirm');
    $modal.off('hidden.bs.modal.dobConfirm');

    $primary.on('click.dobConfirm', function () {
        $modal.modal('hide');
        confirmDob();
    });

    $secondary.on('click.dobConfirm', function () {
        $modal.modal('hide');
    });

    $modal.on('hidden.bs.modal.dobConfirm', focusDob);

    $modal.modal('show');
};

